import paginationComponent from './pagination'

const pagination = {
    install: (Vue) => {
        Vue.component('pagination', paginationComponent)
    }
}

export default pagination
